import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
// Import Containers
import {FullLayout,SimpleLayout} from './containers';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'login',
        loadChildren: './views/auth/login/login.module#LoginModule'
    },
    {
        path: 'user',
        component: FullLayout,
        data: {
            title: 'user'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/users/user.module#UserModule'
    },
    {
        path: 'manageUserAction',
        component: FullLayout,
        data: {
            title: 'manage User Action'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/manageUserAction/manage-user-action.module#ManageUserActionModule'
    },
    {
        path: 'manageFeaturedContent',
        component: FullLayout,
        data: {
            title: 'manage Featured Content'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/manageFeaturedContent/manage-featured-content.module#ManageFeaturedContentModule'
    },
    {
        path: 'manageAdvertisersAction',
        component: FullLayout,
        data: {
            title: 'manage Advertisers Action'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/manageAdvertisersAction/manage-advertisers-action.module#ManageAdvertisersActionModule'
    },
    {
        path: 'manageNotification',
        component: FullLayout,
        data: {
            title: 'manage Notification'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/manageNotification/manage-notification.module#ManageNotificationModule'
    },
    {
        path: 'setting',
        component: FullLayout,
        data: {
            title: 'Setting'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/setting/setting.module#SettingModule'
    },
    {
        path: 'report',
        component: FullLayout,
        data: {
            title: 'Report'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/report/report.module#ReportModule'
    },
    {
        path: 'projects',
        component: FullLayout,
        data: {
            title: 'Projects'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/projects/projects.module#ProjectsModule'
    },
    {
        path: 'groups',
        component: FullLayout,
        data: {
            title: 'Groups'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/groups/groups.module#GroupsModule'
    },
    {
        path: 'events',
        component: FullLayout,
        data: {
            title: 'Events'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/events/events.module#EventsModule'
    },
    {
        path: 'conversations',
        component: FullLayout,
        data: {
            title: 'Conversations'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/messages/messages.module#MessagesModule'
    },
    {
        path: 'notificationTriggers',
        component: FullLayout,
        data: {
            title: 'Notification Triggers'
        },
        canActivate: [AuthGuard],
        loadChildren: './views/notificationTriggers/notificationTriggers.module#NotificationTriggersModule'
    },
    {
        path: '',
        component: FullLayout,
        data: {
            title: 'Home'
        },
        children: [
            {
                path: 'home',
                canActivate: [AuthGuard],
                loadChildren: './views/home/home.module#HomeModule'
            }
        ]
    },

    { path: '**', redirectTo: 'home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/app.routing.ts